import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "@/lib/cn";

// 样式定稿见 styles/ds.css 的 .cs-btn*；每个视图最多一个 default（金色）按钮。
export const buttonVariants = cva("cs-btn", {
  variants: {
    variant: {
      default: "cs-btn-default",
      secondary: "",
      outline: "cs-btn-outline",
      ghost: "cs-btn-ghost",
      destructive: "cs-btn-destructive",
      link: "cs-btn-link",
    },
    size: { md: "", sm: "cs-btn-sm", lg: "cs-btn-lg", icon: "cs-btn-icon", "icon-sm": "cs-btn-icon cs-btn-sm w-7" },
  },
  defaultVariants: { variant: "secondary", size: "md" },
});

export interface ButtonProps extends ComponentProps<"button">, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

export function Button({ className, variant, size, asChild, type, ...props }: ButtonProps) {
  const Comp = asChild ? Slot.Root : "button";
  return <Comp type={asChild ? undefined : (type ?? "button")} className={cn(buttonVariants({ variant, size }), className)} {...props} />;
}
